import { Column } from 'shared/types/models/EditMetrics';
import { isMarkupBudgetColumn } from '../budget';

export function getMarkupBudgetColumnsIndexes(columns: Column[]): number[] {
  return columns.reduce<number[]>((acc, column, colIndex) =>
    isMarkupBudgetColumn(column) ? [...acc, colIndex] : acc
  , []);
}
